import { useSelector } from "react-redux";
import Point from "../../Point";
import {  useGameSounds, NAME_SOUND_ACTIVE } from "@educaplay/core";
import { useEffect, useState, } from "react";
import { GAME_MODES, MAPA_SOUNDS, STATE_POINT, TYPE_POINTS } from "../../../utils/constants";
import { useDispatch } from "react-redux";
import useMap from "../../../hooks/useMap";
import { goToQuestion, saveAnswer } from "@educaplay/store/slices/gameSlice";
import { DialogContent } from "../../DialogContent";
import SwipeableDrawerPoint from "../../SwipeableDrawerPoint";

const wait = (ms) => new Promise(resolve => setTimeout(resolve, ms));
export const InteractivePointInfo = (props) => {

  const { id, disabled, isCurrentQuestion, onClick, setIsInfoScreenActive, isInfoScreenActive } = props;
  const allQuestions = useSelector(state => state.game.questions);
  const screenId = useSelector(state => state.game.questions[state.game.currentIndex].screenId);  
  const questions = allQuestions.filter(question => question.screenId === screenId);
  const associatedIdQuestion = questions.find(question => question.id === id);
  const [showInfoDialog, setShowInfoDialog] = useState(false);
  const { zoomToPoint } = useMap();
  const [state, setState] = useState(STATE_POINT.DEFAULT);
  const gameSound = useGameSounds();
  const dispatch = useDispatch();

  useEffect(() => {

    if (isCurrentQuestion) {
      const answerObject = {
        type: GAME_MODES.EXPLORE,
        viewed: true,
        answer: id
      }

      dispatch(saveAnswer(answerObject));

      const init = async () => {
        gameSound.play(NAME_SOUND_ACTIVE);
        await viewPoint();
      }
      init();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCurrentQuestion])

  const onClickHandler = async () => {

    onClick(id);
    const selectedIndex = allQuestions.findIndex(question => question.id === associatedIdQuestion.id);
    dispatch(goToQuestion(selectedIndex));
    await viewPoint();

  }

  const viewPoint = async () => {
    setState(STATE_POINT.FOCUS);
    zoomToPoint(associatedIdQuestion);
    await wait(200);
    setShowInfoDialog(true);

  }

  const onCloseAdittionalInfo = () => {
    gameSound.play(MAPA_SOUNDS.CHARGE);
    setState(STATE_POINT.CORRECT);
    setShowInfoDialog(false);
  }

  useEffect(() => {
    if (!isCurrentQuestion) {
      const timeOutInfoDialog = setTimeout(() => {
        setShowInfoDialog(false);
        clearTimeout(timeOutInfoDialog);
      }, 150);

      if (state === STATE_POINT.FOCUS || state === STATE_POINT.CORRECT) {
        setState(STATE_POINT.CORRECT);
        return;
      }
      setState(STATE_POINT.DEFAULT);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCurrentQuestion])

  useEffect(() => {
    setIsInfoScreenActive(showInfoDialog);  
  },[showInfoDialog, setIsInfoScreenActive])

  return (
    <>

      <SwipeableDrawerPoint open={showInfoDialog} onClose={onCloseAdittionalInfo}>
        <DialogContent
          mediaType={associatedIdQuestion.media?.type}
          media={associatedIdQuestion.media?.src}
          title={associatedIdQuestion.title}
          description={associatedIdQuestion.description}
          explanation={associatedIdQuestion.explanation} />
      </SwipeableDrawerPoint>

      <Point onClick={onClickHandler} disabled={disabled} type={TYPE_POINTS.INFO} state={state} isInfoScreenActive={isInfoScreenActive} showBalloon />
    </>
  )


}